module.exports = __webpack_public_path__ + "img/1538822345.61ec66f9.jpg";